import { FaFilter } from "react-icons/fa";
import Dropdown from "../../Components/DropDown";

const FilterDropdown = ({ value, onChange, title, list ,keyName ,name }) => {
  return (
    <Dropdown label={name} icon={FaFilter}>
      {(close) => (
      <div className="absolute right-0 mt-2 w-56 bg-white  rounded-md shadow-lg z-50 max-h-64 overflow-y-auto">
        <div className="px-3 py-2">
          <p className="text-xs font-semibold text-gray-500 mb-1">{title}</p>

          <ul className="space-y-1">
            {list?.map((item) => (
              <li
                key={item.key}
                className={`px-3 py-1 rounded cursor-pointer text-sm capitalize ${
                  value?.[keyName] === item.key
                    ? "bg-blue-50 text-blue-600 font-medium"
                    : "hover:bg-gray-100"
                }`}
                onClick={() => {onChange({ [keyName]: item.key }); close();}}
              >
                {item.label}
              </li>
            ))}
          </ul>
        </div>

        <button
          className="w-full text-left px-4 py-2 text-sm text-gray-500 hover:bg-gray-100"
          onClick={() => {onChange({ [keyName]: "" }); close();}}
        >
          Clear filters
        </button>
      </div>
      )}
    </Dropdown>
  );
};

export default FilterDropdown;